<!--
 * @FileDescription: 新增付款单选择条件（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-16（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <a-modal  v-model="isShowModel" class="payment-model"   :footer="null" :title="title"   @cancel="onCancel" >
        <a-table :columns="columns"
                 :dataSource="dataSource"
                 :loading="$store.state.tabLoding"
                 :customRow="rowClick"
                 :pagination="false"
                 :scroll="{x:320,y: 420 }"
                 bordered>
            <template  slot="operation" slot-scope="text, record, index">
                <a-button class="btn-save-next" @click.stop="onSelect(record,index,1)" v-if="!record.isCheck">选择</a-button>
                <a-input v-focus type="button" v-else class="btn-save-next btn-save-next-active" @click.stop="onSelect(record,index,2)" @pressEnter=" e =>handleEnter(e,record,index) " value="选中"></a-input>
            </template>
        </a-table>
    </a-modal>
      <a-modal  v-model="isShowModel1" class="payment-model"   :footer="null" :title="title1"   @cancel="onCancel" >
          <a-table :columns="columns1"
                   :loading="$store.state.tabLoding"
                   :customRow="rowClick"
                   :dataSource="dataSource1"
                   :pagination="false"
                   :scroll="{x:320,y: 420 }"
                   bordered>
              <template  slot="operation" slot-scope="text, record, index">
                  <a-button class="btn-save-next" @click.stop="onSelect1(record,index,1)" v-if="!record.isCheck">选择</a-button>
                  <a-input v-focus type="button" v-else class="btn-save-next btn-save-next-active" @click.stop="onSelect1(record,index,2)" @pressEnter=" e =>handleEnter1(e,record,index) " value="选中"></a-input>
              </template>
          </a-table>
      </a-modal>
  </div>
</template>
<script>
import {fincestoreList,financeList} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from 'moment';
import pick from 'lodash.pick'
import ACol from "ant-design-vue/es/grid/Col";
export default {
    mixins:[mixins],
    data(){
        return{
            isShowModel:false,
            isShowModel1:false,
            title:'选择类别',
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 80,
                    align: "center",
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '类别编号',
                    dataIndex: 'code',
                    key:'code',
                    width:150,
                },
                {
                    title: '类别名称',
                    dataIndex: 'name',
                    key:'name',
                    width:120,
                },
                {
                    title: '',
                    width:130,
                    align:'center',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            dataSource:[],
            title1:'选择科目',
            columns1: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 80,
                    align: "center",
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '科目编号',
                    dataIndex: 'code',
                    key:'code',
                    width:150,
                },
                {
                    title: '科目名称',
                    dataIndex: 'name',
                    key:'name',
                    width:120,
                },
                {
                    title: '操作',
                    width:130,
                    align:'center',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            dataSource1:[],
            isKeycode:false,
            selectIndex:0,
            tabIndex:0,
            isLoding:false
        }
    },
    watch: {

    },
    mounted () {
    },
    created () {

    },
    updated(){
        let that = this
        if(that.isKeycode){
            document.onkeydown = function () {
                if(that.isKeycode){
                    if(window.event.keyCode == 40){
                        if(that.tabIndex == 1){
                            if(that.selectIndex == that.dataSource.length - 1){
                                return;
                            }
                        }else{
                            if(that.selectIndex == that.dataSource1.length - 1){
                                return;
                            }
                        }
                        that.selectIndex += 1
                        if(that.tabIndex == 1){
                            that.dataSource.forEach((item,index)=>{
                                item.isCheck = false
                                if(that.selectIndex == index){
                                    item.isCheck = true
                                }
                            })
                        }else{
                            that.dataSource1.forEach((item,index)=>{
                                item.isCheck = false
                                if(that.selectIndex == index){
                                    item.isCheck = true
                                }
                            })
                        }
                    }
                    if(window.event.keyCode == 38){
                        if(that.selectIndex == 0){
                            return;
                        }
                        that.selectIndex -= 1
                        if(that.tabIndex == 1){
                            that.dataSource.forEach((item,index)=>{
                                item.isCheck = false
                                if(that.selectIndex == index){
                                    item.isCheck = true
                                }
                            })
                        }else{
                            that.dataSource1.forEach((item,index)=>{
                                item.isCheck = false
                                if(that.selectIndex == index){
                                    item.isCheck = true
                                }
                            })
                        }
                    }
                }
            }
        }
    },
    components: {
        ACol,
        AFormItem
    },
    methods: {
        getList(){
            this.dataSource1 = []
            this.$store.state.tabLoding = true
            let data = {
                companyStoreId:this.$store.state.shopId
            }
            data = this.$qs.stringify(data)
            fincestoreList(data,{}).then((res)=>{
                if(res.success){
                    res.result.forEach((item,index)=>{
                        item.isCheck = false
                        if(index == 0){
                            item.isCheck = true
                        }
                        delete item.children
                    })
                    this.dataSource1 = res.result
                    this.$store.state.tabLoding = false

                }
            })
        },
        getList1(value){
            this.$store.state.tabLoding = true
            this.dataSource = []
            let data = {
                type:value,
                companyStoreId : this.$store.state.shopId,
                companyId : this.$store.state.companyId
            }
            data =   this.$qs.stringify(data)
            financeList(data,{}).then((res)=>{
                if(res.success){
                    res.result.forEach((item,index)=>{
                        item.isCheck = false
                        if(index == 0){
                            item.isCheck = true
                        }
                        delete item.children
                    })
                    this.dataSource = res.result
                    this.$store.state.tabLoding = false
                }
            })
        },
        /**
        * @description: 此为方法注释（方法描述）
        */
        onOpen(index,index1){
            this.isKeycode = true
            this.selectIndex = 0
            this.tabIndex = index
            if(index == 1){
                this.isShowModel = true
                this.getList1(index1)
            }else if(index == 2){
                this.isShowModel1 = true
                this.getList()
            }
        },
        onCancel(){
          this.isKeycode = false
            this.isShowModel = false
            this.isShowModel1 = false
        },
        /**
         * @description: 选择类目（方法描述）
         */
        onSelect(record,index,index1){
            if(index1 == 1){
                record.isCheck = true
                this.isShowModel = false
                this.$emit('onSelectModelLei',record,index)
            }else{
                this.isShowModel = false
                this.$emit('onSelectModelLei',record,index)
            }
        },
        //选择
        rowClick(record, index){
            return {
                on: {
                    dblclick:()=>{
                        record.isCheck = true
                        if(this.tabIndex == 1){
                            this.isShowModel = false
                            this.$emit('onSelectModelLei',record,index)
                        }else{
                            this.isShowModel1 = false
                            this.$emit('onSelectModelKe',record,index)
                        }
                    }
                }
            }
        },
        /**
         * @description: 选择类目（方法描述）
         */
        onSelect1(record,index,index1){
            if(index1 == 1){
                record.isCheck = true
                this.isShowModel1 = false
                this.$emit('onSelectModelKe',record,index)
            }else{
                this.isShowModel1 = false
                this.$emit('onSelectModelKe',record,index)
            }
        },
        handleEnter1(e,record,index){
            this.isShowModel1 = false
            this.$emit('onSelectModelKe',record,index)
        },

        handleEnter(e,record,index){
            this.isShowModel = false
            this.$emit('onSelectModelLei',record,index)
        },
    },

}
</script>
<style lang="scss">
    .payment-model{
        width: 800px !important;
        height: 650px !important;
        .ant-table-body{
            max-height: 420px !important;
            overflow-x: hidden;
        }
        .ant-modal-body{
            padding: 0 24px 24px;
        }
    }
</style>
<style scoped lang="scss">
    .btn-save-next{
        width: 60px;
       height: 30px !important;
    }
    .btn-save-next-active{
        height: 30px !important;
        background: var(--co) !important;
        color: #fff;
        border: none !important;
      border-radius: 10px !important;
    }
</style>
